/**
 * Enums e tipos de pagamento compartilhados entre os domínios de settlement
 * (baixa/liquidação de título) e billing (registrar pagamento de faturas).
 *
 * Ficam fora de `pages/` porque os componentes reutilizáveis em
 * `components/molecules/payment/` dependem deles.
 */
/* eslint-disable @typescript-eslint/no-redeclare -- const + type de mesmo nome é
   declaration merging do TS (padrão herdado de pages/settlement/constants), não redeclaração. */

export const PaymentType = {
    FINANCIAL: 'FINANCIAL',
    DEBT_CONFESSION: 'DEBT_CONFESSION',
    ASSET_DATION: 'ASSET_DATION',
} as const satisfies Record<string, string>;
export type PaymentType = typeof PaymentType[keyof typeof PaymentType];

export const paymentTypeLabels: Record<string, string> = {
    FINANCIAL: 'Financeiro',
    DEBT_CONFESSION: 'Confissão de Dívida',
    ASSET_DATION: 'Dação de Bens',
};

export const PaymentMethod = {
    PIX: 'PIX',
    TED: 'TED',
    BOLETO: 'BOLETO',
    TRANSFER: 'TRANSFER',
} as const satisfies Record<string, string>;
export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];

export const paymentMethodLabels: Record<string, string> = {
    PIX: 'PIX',
    TED: 'TED',
    TRANSFER: 'Transferência (TED)',
    BOLETO: 'Boleto',
};

export const PaymentSource = {
    SACADO: 'SACADO',
    EMITENTE: 'EMITENTE',
    AVALISTA: 'AVALISTA',
    CREDOR: 'CREDOR',
} as const satisfies Record<string, string>;
export type PaymentSource = typeof PaymentSource[keyof typeof PaymentSource];

export const paymentSourceLabels: Record<string, string> = {
    SACADO: 'Sacado',
    EMITENTE: 'Emitente',
    AVALISTA: 'Avalista',
    CREDOR: 'Credor',
};

export const SettlementType = {
    TOTAL: 'TOTAL',
    PARCIAL: 'PARCIAL',
    ATRASO: 'ATRASO',
    ANTECIPADO: 'ANTECIPADO',
} as const satisfies Record<string, string>;
export type SettlementType = typeof SettlementType[keyof typeof SettlementType];

export const AssetType = {
    VEHICLE: 'VEHICLE',
    MACHINERY: 'MACHINERY',
    REAL_ESTATE: 'REAL_ESTATE',
    PRODUCT: 'PRODUCT',
    GRAIN: 'GRAIN',
} as const satisfies Record<string, string>;
export type AssetType = typeof AssetType[keyof typeof AssetType];

export const assetTypeLabels: Record<string, string> = {
    VEHICLE: 'Veículo',
    MACHINERY: 'Maquinário',
    REAL_ESTATE: 'Imóvel',
    PRODUCT: 'Produto',
    GRAIN: 'Grãos',
};

export interface AssetDationItem {
    asset_type: AssetType;
    description: string;
    estimated_value: number;
    // Vehicle
    plate?: string;
    chassis?: string;
    renavam?: string;
    brand?: string;
    model?: string;
    year?: number;
    // Machinery
    serial_number?: string;
    // Real Estate
    registration_number?: string;
    registry_office?: string;
    total_area?: number;
    built_area?: number;
    land_type?: 'RURAL' | 'URBAN';
    // Product / Grain
    product_type?: string;
    quantity?: number;
    unit?: string;
    storage_location?: string;
}
